<template>
  <div class="container-fluid bg-tertiary-app-admin z-2 px-4">
    <Sidebar />
    <div class="row min-vh-100 g-lg-1 g-xl-4 g-xxl-5">
      <!-- <div
        class="d-none d-md-none d-lg-block col-lg-2 bg-tertiary-app-admin py-3 ps-lg-2 pe-lg-3 ps-xl-2 pe-xl-3 ps-xxl-3 pe-xxl-5"
      >
        <Sidebar />
      </div> -->
      <div class="col-12 col-lg-12 py-3 px-xxl-5">
        <!-- Aquí va el contenido principal -->
        <NavBarHeader />
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import Sidebar from '@/components/layout/admin/menu/MenuSidebar.vue'
import NavBarHeader from '@/components/layout/admin/header/NavBar.vue'
</script>
